module.exports = __webpack_public_path__ + "media/images/tiedye/design-6-dcc815bf36e769130a0bc6dc9808bba6.jpg";